module.exports = __webpack_public_path__ + "static/media/therapist.34245407.svg";